var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('customer-detail',{attrs:{"customer":_vm.item,"isLoading":_vm.isLoading,"ordersShowDestination":false,"panelInfoTitle":'I miei dati',"ordersTitle":'Ultimi ordini'}})
}
var staticRenderFns = []

export { render, staticRenderFns }